import { Injectable } from '@angular/core';
import { Config } from './config';
import { CustomerService } from 'app/shared/services/customer.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LocationArgs, Locations } from '../models/locations';

@Injectable()
export class LocationDashboardService {
    constructor(public http: HttpClient, public customerService: CustomerService) {}

    /**
     * Below method would be used to fetch the inactive and active locations
     * @param params represents the location service paramaters
     */
    public getLocations(params: LocationArgs) {
        let httpParams: HttpParams = new HttpParams();
        Object.keys(params).forEach(function (key) {
            httpParams = httpParams.append(key, params[key]);
        });

        return this.http.get<Locations[]>(`${Config.urls.locations}/${params.customerId}`, { params: httpParams });
    }

    /**
     * Below method would be used to fetch the inactive and active locations
     * @param params represents the location service paramaters
     */
    public getLocationsList(params: LocationArgs) {
        let httpParams: HttpParams = new HttpParams();
        Object.keys(params).forEach(function (key) {
            httpParams = httpParams.append(key, params[key]);
        });

        return this.http.get<Locations[]>(`${Config.urls.locations}/${params.customerId}`, { params: httpParams });
    }
}
